import { useNavigate } from "react-router-dom";
import { useWriterDashboard, useUpdateWriterProfile } from "@/hooks/useWriter";
import { ProfileEditor } from "@/components/writer/ProfileEditor";
import { Skeleton } from "@/components/ui/Skeleton";

export function ProfilePage() {
  const navigate = useNavigate();
  const { data: dashboard, isLoading } = useWriterDashboard();
  const updateMutation = useUpdateWriterProfile();

  if (isLoading) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-10">
        <Skeleton className="h-8 w-48 mb-6" />
        <Skeleton className="h-96" />
      </div>
    );
  }

  if (!dashboard) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-20 text-center">
        <h2 className="text-2xl font-display font-bold">
          Not onboarded yet
        </h2>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-10">
      <h1 className="text-2xl font-display font-bold mb-6">Edit Profile</h1>
      <ProfileEditor
        initial={dashboard.writer}
        onSubmit={(data) => {
          updateMutation.mutate(data, {
            onSuccess: () => navigate("/writer/dashboard"),
          });
        }}
        loading={updateMutation.isPending}
      />
    </div>
  );
}
